(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinterest-embed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SCRIPT_SRC = 'https://assets.pinterest.com/js/pinit.js';

    function scriptOnPage() {
      return Boolean(document.querySelector('script[src*="assets.pinterest.com/js/pinit.js"]'));
    }

    function sizeWidgets() {
      document.querySelectorAll('[data-pinterest-embed]').forEach(function (wrap) {
        var anchor = wrap.querySelector('a[data-pin-do]');
        if (!anchor) return;
        var width = Math.floor(wrap.clientWidth);
        if (width < 130) width = 130;
        if (width > 800) width = 800;
        anchor.setAttribute('data-pin-board-width', String(width));
      });
    }

    function loadPinit() {
      if (window.PinUtils) {
        window.PinUtils.build();
        return;
      }
      if (scriptOnPage()) return;
      var s = document.createElement('script');
      s.src = SCRIPT_SRC;
      s.async = true;
      s.defer = true;
      document.body.appendChild(s);
    }

    function init() {
      sizeWidgets();
      loadPinit();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function () {
      sizeWidgets();
      if (window.PinUtils) {
        window.PinUtils.build();
      } else {
        loadPinit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-video-hero]';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function setupHero(root) {
      var video = root.querySelector('video');
      if (!video) return;

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;

      function showStatic() {
        root.classList.add('video-hero--static');
        video.pause();
        video.removeAttribute('autoplay');
      }

      if (prefersReducedMotion()) {
        showStatic();
        return;
      }

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          showStatic();
        });
      }

      video.addEventListener('error', showStatic);
    }

    function init(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll(SELECTOR).forEach(setupHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
